const version = {
    name: 'dev',
    domain: 'localhost',
}

export default version